// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.R6m4ez46EDqAGaKj01qP {
	display: flex;
	flex-direction: column;
}

.IQtqiQCIeX6ez0oBSp1n {
	margin-bottom: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ExpiresDate/AdvanceMode/AdvanceMode.pcss"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;AACpB","sourcesContent":[".container {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.input {\n\tmargin-bottom: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `R6m4ez46EDqAGaKj01qP`,
	"input": `IQtqiQCIeX6ez0oBSp1n`
};
export default ___CSS_LOADER_EXPORT___;
